import type { ReportInfoExt } from "../types/reportTypes";
import FilteredReportList from "./FilteredReportList";
import ReportsGrid from "./ReportsGrid";

interface Props {
  reports: ReportInfoExt[];
  isGroupSelected?: boolean;
  onToggleFavorite?: (reportId: string) => void;
}

const getReportId = (report: ReportInfoExt) => report.reportId;

const ReportsGridWrapper = ({ reports, isGroupSelected, onToggleFavorite }: Props) => (
  <FilteredReportList items={reports} getItemId={getReportId}>
    {(filteredReports) => (
      <ReportsGrid reports={filteredReports} isGroupSelected={isGroupSelected} onToggleFavorite={onToggleFavorite} />
    )}
  </FilteredReportList>
);

export default ReportsGridWrapper;
